<template>
  <a :href="href" class="ni-more-link">
    <span>{{ lang === 'zh' ? '更多详情' : 'View More' }}</span>
    <span class="ni-more-link__icon" aria-hidden="true">
      <svg class="ni-more-link__icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 6l6 6-6 6" />
      </svg>
    </span>
  </a>
</template>

<script>
export default {
  name: 'MoreLink',
  props: {
    href: { type: String, default: '#' },
    lang: { type: String, default: 'zh' }
  }
};
</script>
